import { connect } from 'react-redux';

import get from 'lodash/get';

import ExternalLinksComponent from './ExternalLinksComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import { confirmToDeleteExternalLink, getExternalLinksList } from './actions';

import {
  getExternalAccountListParams,
  getExternalAccountsByType,
} from '../selectors';

const LIST_KEY = 'external_links';

const mapStateToProps = (state) => ({
  listKey: LIST_KEY,
  listParams: getExternalAccountListParams(LIST_KEY)(state),
  items: getExternalAccountsByType(LIST_KEY)(state),
  buildingOptions: get(state, 'buildings'),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => getBuildingsForFilter(dispatch),
  getItems: (queryParams) => getExternalLinksList(dispatch, queryParams),
  deleteExternalAccount: (accountId, listParams) =>
    confirmToDeleteExternalLink(
      dispatch,
      accountId,
      getExternalLinksList,
      listParams,
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExternalLinksComponent);
